import { connect } from 'react-redux'

import { loadActivitiesForArea } from '../../actions/area-activities'

import QAServicingTabs from '../../components/qa-servicings/qa-servicing-tabs'

function mapStateToProps (state, ownProps) {
  const qaServicing = state.qaServicings[ownProps.qaServicingId]
  const area = state.areas[qaServicing.area]

  return {
    qaServicing,
    area
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadActivitiesForArea(ownProps.areaId))

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QAServicingTabs)



// WEBPACK FOOTER //
// ./src/containers/qa-servicings/qa-servicing-tabs-container.js